import { useEffect, useState } from "react";
import api from "@/lib/api";

// Returns "checking" | "open" | "locked" for a given area based on admin lock settings.
// "open" means the admin disabled the PIN for that area, so gates should let users in.
export function useAreaOpen(area) {
  const [state, setState] = useState("checking");
  useEffect(() => {
    let alive = true;
    api.get("/area-locks")
      .then((r) => { if (alive) setState(r.data && r.data[area] === false ? "open" : "locked"); })
      .catch(() => { if (alive) setState("locked"); });
    return () => { alive = false; };
  }, [area]);
  return state;
}
